import { MessageSquare } from "lucide-react";

import EntryDetails from "components/LogItem/elements/EntryDetails";
import TextContentDialog from "components/LogItem/elements/TextContentDialog";
import { basicDateFormatter } from "components/LogItem/messages/dates";
import { getModelLink } from "components/LogItem/messages/modelLinks";

const TranscriptActions = ({
  item: {
    info: { transcript },
  },
}) => (
  <TextContentDialog
    label="View Transcript"
    title="Transcript"
    disabled={!transcript}
  >
    {transcript}
  </TextContentDialog>
);

/**
 * A conversation an agent logged by hand. `channel` names it in the sentence,
 * and `addressRow` is the row for where the conversation took place.
 */
const conversationEntry = ({ title, channel, addressRow }) => ({
  title,
  icon: MessageSquare,
  message: ({ auditable_id, contact_id, contact_name, user_name, info }) => (
    <>
      <p>
        {user_name} logged {channel} conversation with{" "}
        {getModelLink(contact_id, "Contact", { label: contact_name })}.
      </p>
      <EntryDetails
        rows={[
          { label: "Date", value: basicDateFormatter(info.conversation_date) },
          addressRow(info),
          { label: "Message ID", value: auditable_id },
          { label: "Comments", value: info.comment },
        ]}
      />
    </>
  ),
  actions: TranscriptActions,
});

const phoneRow = ({ phone_number }) => ({
  label: "Phone Number",
  value: phone_number,
});

export const TEXT_MESSAGE_EVENTS = {
  text_whatsapp_sent: conversationEntry({
    title: "WhatsApp Conversation Logged",
    channel: "a WhatsApp",
    addressRow: phoneRow,
  }),
  text_sms_sent: conversationEntry({
    title: "SMS Conversation Logged",
    channel: "an SMS",
    addressRow: phoneRow,
  }),
  text_linkedin_sent: conversationEntry({
    title: "LinkedIn Conversation Logged",
    channel: "a LinkedIn",
    addressRow: ({ url }) => ({ label: "URL", value: url }),
  }),
};
